// extracted by mini-css-extract-plugin
export default {"root":"Textarea_root__id9f6","textarea":"Textarea_textarea__bzonT"};